<main class="flex h-screen flex-col items-center justify-center bg-neutral px-6 text-center">
  <div class="mt-6 flex flex-col items-center lg:-mt-28">
    <app-logo class="w-[10rem] text-kek-purple"></app-logo>

    <h1 class="-mt-4 text-[2.5rem] text-inverted-neutral space-grotesk-600">
      Welcome {{ name }}
    </h1>

    <p
      class="mt-2 max-w-full break-words px-4 text-[1.5rem] text-support-text inter-400 whitespace-normal md:whitespace-nowrap"
    >
      Please click <span class="inter-700 text-inverted-neutral">Start</span>
      when you are ready to begin the survey
    </p>
  </div>

  <div class="mt-48">
    <button
      class="bg-transparent border border-[#764FD4] text-[#764FD4] hover:bg-[#764FD4]/10 focus:ring-2 focus:ring-[#764FD4]/20 px-12 py-4 rounded-full inter-500 text-[1rem] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      (click)="start()"
      [disabled]="starting()"
    >
      {{ starting() ? 'Starting...' : 'Start' }}
    </button>
  </div>
</main>
